// 运行时配置(对齐原站:多线路 + 可切换 baseURL/socket)
// 原站 API base 示例:https://vip.wokekj.com:50983 (业务前缀 /biz)
// 你接自己后端时改这里,或由 /getBaseSetting 下发后写入 store。

// 开发:api 留空,请求走 devServer proxy('/api' → lottery-go 后端,见 vue.config.js)
// 生产:由 /getBaseSetting 下发真实后端域名写入 store。
export const DEFAULT_LINES = [
  { name: '线路1', api: '', ws: '' },
  { name: '线路2', api: '', ws: '' },
  { name: '线路3', api: '', ws: '' },
  { name: '线路4', api: '', ws: '' }
]

export const API_PREFIX = '/api/v1/admin' // lottery-go 群主后台接口前缀(原站为 /biz)

// crypto:AES 密钥由服务端下发,存本地(原站键名 PC_ROBOT_CRYPTO)
export const CRYPTO_KEY_STORAGE = 'PC_ROBOT_CRYPTO'
export const TOKEN_STORAGE = 'REMEM_BER_INFO'

// 融云 IM
export const RONG_APPKEY = '' // TODO: 填融云 AppKey
export const RONG_NAVIGATORS = ['https://nav.sg-light-edge.com', 'https://nav-b.sg-light-edge.com']
